
import Vue from 'vue';
import PersonCertificateImage from "../assets/shl_certificate_person.jpg";
import GroupCertificateImage from "../assets/shl_certificate_team.jpg";
import mommentManager from 'moment';
import apiConfig from './api-defines';
import StoreManager from './data-store';
import Router from 'vue-router';
import vue from "../main";
import WechatManager from './weixin.config';


import BasketballCertificateImage from '../assets/shl_small_basketball_certificate_back_image.jpg';

import BasketballCertLevelImage1 from '../assets/shl_small_baskeball_level_1.png';
import BasketballCertLevelImage2 from '../assets/shl_small_baskeball_level_2.png';
import BasketballCertLevelImage3 from '../assets/shl_small_baskeball_level_3.png';

import BasketballCertNoteImage1 from '../assets/shl_small_baskeball_note_1.png';
import BasketballCertNoteImage2 from '../assets/shl_small_baskeball_note_2.png';
import BasketballCertNoteImage3 from '../assets/shl_small_baskeball_note_3.png';

import DownloadManager from '../js/download';


let testAppIdObject = {
  registerId: null,
  payId: null,
  alreadyRegister: false,
};

Vue.prototype.testAppIdObject = testAppIdObject;

String.prototype.removeBlanks = function () {
  // let reg = new RegExp('', 'g');
  let patt = /\s*|\t*|\n*/g;
  return this.replace(patt, '');
}

/*
* 去除头尾的空格
* */
String.prototype.removeNamesBlank = function() {
  let patt = /^(\s*|\t*|\n*)+|(\s*|\t*|\n*)+$/g;
  return this.replace(patt, '');
}

String.prototype.isPhoneNumber = function () {
  let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  return reg.test(this);
}

String.prototype.pwdLevel = function () {
  var modes = 0;
  if (this.length < 1) return modes;
  if (/\d/.test(this)) modes++;
  if (/[a-z]/.test(this)) modes++;
  if (/[A-Z]/.test(this)) modes++;
  if (/\W/.test(this)) modes++;
  if (this.length < 6) return 1;
  if (modes < 2) return 1;
  if (modes  < 4) return 2;
  return 3;
}
Vue.prototype.loadFile = function (name) {
  const xhr = new XMLHttpRequest()
  const okStatus = document.location.protocol === 'file:' ? 0 : 200
  xhr.open('GET', name, false);
  xhr.overrideMimeType('text/html;charset=utf-8')// 默认为utf-8
  xhr.send(null)
  return xhr.status === okStatus ? xhr.responseText : null
};

Vue.prototype.unicodeToUtf8 = function (name) {
  data = data.replace(/\\/g, '%')
  return unescape(data)
};

var canvasToImage = function (canvas) {
  // console.log(canvas);
  let image = canvas.toDataURL("image/png");
  return image;
};


var canvasVailidDateText = function(user) {
  let validDate = mommentManager(user.memberValidDate);
  if (validDate.isValid()) {
    let text2 = validDate.format('YYYY.MM.DD');
    let issueDate = validDate.add('-1', 'years');
    issueDate.add('1', 'days');
    return issueDate.format('YYYY.MM.DD') + ' ~ ' + text2;
  }
  return '';
};

var issueDate = function(user) {
  let validDate = mommentManager(user.memberValidDate);
  if (validDate.isValid()) {
    let issueDate = validDate.add('-1', 'years');
    issueDate.add('1', 'days');
    return issueDate.format('YYYY.MM.DD');
  }
  return  '';
};


var drawPersonCanvas = function (user, complete) {
  if (user == null || user == undefined) {
    return;
  }
  let bgImage = new Image();
  bgImage.src = PersonCertificateImage;
  bgImage.onload = function() {
    const casWidth = bgImage.width;
    const casHeight = bgImage.height;
    let cas = document.createElement("canvas");
    let context = cas.getContext("2d");
    cas.setAttribute("width", casWidth.toString(10));
    cas.setAttribute("height", casHeight.toString(10));
    context.drawImage(bgImage, 0, 0);

    context.fillStyle = '#333333';

    let name = user.name;
    if (name != null && name.length > 0) {
      name = name.removeBlanks();
      context.beginPath();
      context.textAlign = 'center';
      context.font = 'bold 60px Arial';
      let nameX = Math.round(casWidth * 0.5);
      let nameY = Math.round(casHeight * 0.4);
      context.fillText(name, nameX, nameY);
      context.closePath();
    }

    context.font = 'normal 25px Arial';
    context.textAlign = 'left';
    let certiNumberX = Math.round(casWidth * 0.2751);
    let certiNumberY = Math.round(casHeight * 0.70101);
    let certificateNumber = user.certificateNo == null ? '' : user.certificateNo;
    context.fillText(certificateNumber, certiNumberX, certiNumberY);
    let validDateX = certiNumberX;
    let validDateY = Math.round(casHeight * 0.753);
    let validDateText = canvasVailidDateText(user);
    context.fillText(validDateText, validDateX, validDateY);

    let issueDateText = issueDate(user);
    let issueDateY = validDateY;
    let issueDateX = Math.round(casWidth * 0.694);
    context.fillText(issueDateText, issueDateX, issueDateY);

    setTimeout(function () {
      let image = canvasToImage(cas);
      complete(image);
    }, 100);
  }
};


var drawGroupCanvas = function (user, complete) {
  let bgImage = new Image();
  bgImage.src = GroupCertificateImage;
  bgImage.onload = function() {
    const casWidth = bgImage.width;
    const casHeight = bgImage.height;
    let cas = document.createElement("canvas");
    let context = cas.getContext("2d");
    cas.setAttribute("width", casWidth.toString(10));
    cas.setAttribute("height", casHeight.toString(10));
    context.drawImage(bgImage, 0, 0);
    context.fillStyle = '#333333';

    let name = user.name;
    if (name != null && name.length > 0) {
      name = name.removeBlanks();
      context.beginPath();
      context.textAlign = 'center';
      context.font = 'bold 60px Arial';
      let nameX = Math.round(casWidth * 0.5);
      let nameY = Math.round(casHeight * 0.410);
      context.fillText(name, nameX, nameY);
      context.closePath();
    }

    context.font = 'normal 25px Arial';
    context.textAlign = 'left';

    let certiNumberX = Math.round(casWidth * 0.2701);
    let certiNumberY = Math.round(casHeight * 0.773);

    let certificateNumber = user.certificateNo == null ? '' : user.certificateNo;

    context.fillText(certificateNumber, certiNumberX, certiNumberY);

    let validDateX = certiNumberX;

    let validDateY = Math.round(casHeight * 0.825);

    let validDateText = canvasVailidDateText(user);

    context.fillText(validDateText, validDateX, validDateY);


    let issueDateText = issueDate(user);
    let issueDateY = validDateY;
    let issueDateX = Math.round(casWidth * 0.704);

    context.fillText(issueDateText, issueDateX, issueDateY);
    setTimeout(function () {
      let image = canvasToImage(cas);
      complete(image);
    }, 300);

  }
};

Vue.prototype.drawCertificateImage = function (user, complete) {
  if (user == undefined || user == null) {
    return;
  }
  let isTeam = user.isTeam;
  if (isTeam == 1) {
    drawGroupCanvas(user, complete);
  } else {
    drawPersonCanvas(user, complete);
  }
};



let levelImageGet = function(levelValue) {
  switch (levelValue) {
    case "一级":
      return BasketballCertLevelImage1;
    case "二级":
      return BasketballCertLevelImage2;
    case "三级":
      return BasketballCertLevelImage3;
    default:
      return null;
  }
};

let noteImageGet = function(levelValue) {
  switch (levelValue) {
    case "一级":
      return BasketballCertNoteImage1;
    case "二级":
      return BasketballCertNoteImage2;
    case "三级":
      return BasketballCertNoteImage3;
    default:
      return null;
  }
};

/*
* 绘制个人篮球训练证书图片
* */
Vue.prototype.drawBasketballTrainingCertificateImage = function (user, complete) {
  if (user == undefined || user == null) {
    return;
  }


  let level = user.level;
  let levelImage = levelImageGet(level);
  let noteImage = noteImageGet(level);
  let userIcon = user.headPortrait;

  let count = 0;
  let maxValue = 1;

  let levelImageElement = null;
  let noteImageElement = null;
  let userIconImageElement = null;
  let bgImage = new Image();

  let drawMyCanvas = function () {

    if (count < maxValue) {
      return;
    }
    const casWidth = bgImage.width;
    const casHeight = bgImage.height;

    let cas = document.createElement("canvas");
    let context = cas.getContext("2d");
    cas.setAttribute("width", casWidth.toString(10));
    cas.setAttribute("height", casHeight.toString(10));
    context.drawImage(bgImage, 0, 0);
    context.fillStyle = '#333333';

    // let name = user.name;
    // 2寸照片尺寸: 626×413（像素）; 3.5cm * 4.9cm
    if (userIconImageElement != null) {

      let userDefaultWidth = 413;
      let userDefaultHeight = 626;

      let userDefaultX = casWidth * 0.2255;
      let userDefaultY = casHeight * 0.290;
      // let userWidth = Math.ceil(userIconImageElement.width );
      // let userHeight = Math.ceil(userIconImageElement.height);

      let imageWidth = userIconImageElement.width;
      let imageHeight = userIconImageElement.height;

      let userWidth = imageWidth;
      let userHeight = imageHeight;

      if (imageWidth > userDefaultWidth) {
        let ratio = imageWidth / userDefaultWidth;
        userWidth = userDefaultWidth;
        userHeight = Math.round(imageHeight / ratio);
      }

      let userX = Math.round(userDefaultX + (userDefaultWidth - userWidth) * 0.5);
      let userY = Math.round(userDefaultY + (userDefaultHeight - userHeight) * 0.5);

      context.drawImage(userIconImageElement, userX, userY, userWidth, userHeight);
    }


    let levelX = Math.ceil(casWidth * 0.212);
    let levelY = Math.ceil(casHeight * 0.595);
    context.drawImage(levelImageElement, levelX, levelY);

    let noteX = Math.ceil(casWidth * 0.4385);
    let noteY = Math.ceil(casHeight * 0.555);
    context.drawImage(noteImageElement, noteX, noteY);

    context.beginPath();
    // context.fillStyle('#333333');
    context.textAlign = 'center';
    context.font = 'bold 70px Arial';

    // context.font = 'bold 14px Arial';
    let name = user.name;
    // console.log(name);
    let nameX = Math.ceil(casWidth * 0.645);
    let nameY = Math.ceil(casHeight * 0.362);
    context.fillText(name, nameX, nameY);

    let sex = user.sex;
    let sexX = Math.ceil(casWidth * 0.645);
    let sexY = Math.ceil(casHeight * 0.420);
    context.fillText(sex, sexX, sexY);

    let age = user.age;
    let ageX = Math.ceil(casWidth * 0.645);
    let ageY = Math.ceil(casHeight * 0.480);
    context.fillText(age, ageX, ageY);

    context.beginPath();
    context.textAlign = 'center';
    context.font = 'normal 46px Arial';

    let createTime = user.createTime;
    let timeStr = mommentManager(createTime).format('YYYY.MM.DD');

    let timeX = Math.ceil(casWidth * 0.5580);
    let timeY = Math.ceil(casHeight * 0.7755);
    context.fillText(timeStr, timeX, timeY);
    setTimeout(function () {
      let image = canvasToImage(cas);
      complete(image);
    }, 300);
  };

  if (levelImage != null) {
    maxValue += 1;
    levelImageElement = new Image();
    levelImageElement.src = levelImage;
    levelImageElement.onload = function () {
      count += 1;
      drawMyCanvas();
    };
  }
  if (noteImage != null) {
    maxValue += 1;
    noteImageElement = new Image();
    noteImageElement.src = noteImage;
    noteImageElement.onload = function () {
      count += 1;
      drawMyCanvas();
    };
  }

  if (userIcon != undefined && userIcon != null && userIcon.length > 0) {
    maxValue += 1;

    DownloadManager.getBlob(userIcon).then(function (img) {
      let a = new FileReader();
      a.onload = function (e) {
        userIconImageElement = new Image();
        userIconImageElement.src = e.target.result;
        userIconImageElement.onload = function () {
          count += 1;
          drawMyCanvas();
        };
      };
      a.readAsDataURL(img);
      // count += 1;
      // drawMyCanvas();
      return;
    }).catch(function (status) {
      // console.log('下载失败！', 'status = ', status);
      count += 1;
      drawMyCanvas();

    });
  }

  bgImage.src = BasketballCertificateImage;
  bgImage.onload = function () {
    count += 1;
    drawMyCanvas();
  }
};


Vue.prototype.checkToken = function(store, complete) {
  let token = StoreManager.getToken();
  let _this = this;
  if (token == null) {
    complete({
      code: -1
    });
    return ;
  }
  if (token != null) {
    apiConfig.ajax.checkSession({
      token
    },function (data) {
      let code = data.code;
      if (code == 1) {
        // _this.$toast('过期');
        StoreManager.clearUser();
      }
      complete({
        code,
      });
    },function (data) {
      StoreManager.clearUser();
      complete({
        code: 1,
      });
    });
  }
}

Vue.prototype.isPc = function () {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'
  ];
  var flag = true;
  for (var i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) != -1) {
      flag = false;
      break;
    }
  }
  return flag;
};


Vue.prototype.isWeixin = function () {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
};


Vue.prototype.configShareWx = function (url, shareObject) {
  if (!this.isWeixin()) {
    return;
  }
  apiConfig.ajax.userWxConfigGet(url, function (data) {
    let code = data.code;
    if (code == 0) {
      let config = data.data;
      let appId = config.appId
      testAppIdObject.registerId = appId;
      let nonceStr = config.nonceStr
      let signature = config.signature
      let timestamp = config.timestamp
      if (timestamp != null && timestamp != '') {
        wx.config({
          debug: false,
          appId: appId,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'chooseWXPay',
          ]
        });

        wx.ready(function () {
          let shareObj = {
            title: shareObject.title,
            desc: shareObject.desc,
            link: shareObject.link,
            imgUrl: shareObject.imgUrl,
            success: function () {
              // console.log('分享成功！');
            },
            cancel: function () {
              // console.log('分享取消！');
            }
          };
          wx.onMenuShareTimeline(shareObj)
          wx.onMenuShareAppMessage(shareObj)
        })
      }
    }

  }, function (data) {

  });
};

Vue.prototype.defaultDateFormat = function (date) {
  let nowDate = mommentManager(date);
  if (nowDate.isValid()) {
    return nowDate.format('yyyy-MM-DD');
  }
};

Vue.prototype.toPercent = function(point) {
  let str = Number(point * 100).toFixed(1);
  str += '%';
  return str;
};

Vue.prototype.weichatAutoState = {
  login: WechatManager.jsApiLoginStatus,
  pay: WechatManager.jsapiPayStatus,
};



Vue.prototype.isSafari = function() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
    ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
    return true;
  } else {
    return false;
  }
}


Vue.prototype.isMobile = function() {
  // var userAgentInfo = navigator.userAgent;

  // var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];

  var mobile_flag = false;
  if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
    mobile_flag = true;
  }
  if (mobile_flag) {
    return mobile_flag;
  }

  //根据userAgent判断是否是手机
  // for (var v = 0; v < mobileAgents.length; v++) {
  //   if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
  //     mobile_flag = true;
  //     break;
  //   }
  // }

  var screen_width = window.screen.width;
  var screen_height = window.screen.height;

  //根据屏幕分辨率判断是否是手机
  if(screen_width < 500 && screen_height < 800){
    mobile_flag = true;
  }
  return mobile_flag;
}


/**
 * 身份证校验算法
 */
var vcity={ 11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
  21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",
  33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",
  42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",
  51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",
  63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"
};



function checkCardNo(card) {
  //是否为空
  if(card === '') {
    return false;
  }
  //校验长度，类型
  if(isCardNo(card) === false){
    return false;
  }
  //检查省份
  if(checkProvince(card) === false){
    return false;
  }
  //校验生日
  if(checkBirthday(card) === false){
    return false;
  }
  //检验位的检测
  if(checkParity(card) === false){
    return false;
  }
  return true;
};

//检查号码是否符合规范，包括长度，类型
var isCardNo = function(card){
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
  if(reg.test(card) === false){
    return false;
  }
  return true;
};

//取身份证前两位,校验省份
var checkProvince = function(card){
  var province = card.substr(0,2);
  if(vcity[province] == undefined){
    return false;
  }
  return true;
};

//检查生日是否正确
var checkBirthday = function(card){
  var len = card.length;
  //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
  if(len == '15'){
    var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    var arr_data = card.match(re_fifteen);
    var year = arr_data[2];
    var month = arr_data[3];
    var day = arr_data[4];
    var birthday = new Date('19'+year+'/'+month+'/'+day);
    return verifyBirthday('19'+year,month,day,birthday);
  }

  //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if(len == '18'){
    var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
    var arr_data = card.match(re_eighteen);
    var year = arr_data[2];
    var month = arr_data[3];
    var day = arr_data[4];
    var birthday = new Date(year+'/'+month+'/'+day);
    return verifyBirthday(year,month,day,birthday);
  }
  return false;
};

//校验日期
var verifyBirthday = function(year,month,day,birthday){
  var now = new Date();
  var now_year = now.getFullYear();
  //年月日是否合理
  if(birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day){
    //判断年份的范围（3岁到100岁之间)
    var time = now_year - year;
    if(time >= 3 && time <= 100){
      return true;
    }
    return false;
  }
  return false;
};

//校验位的检测
var checkParity = function(card){
  //15位转18位
  card = changeFivteenToEighteen(card);
  var len = card.length;
  if(len == '18'){
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
    var cardTemp = 0, i, valnum;
    for(i = 0; i < 17; i ++){
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    valnum = arrCh[cardTemp % 11];
    if (valnum == card.substr(17, 1)){
      return true;
    }
    return false;
  }
  return false;
};

//15位转18位身份证号
var changeFivteenToEighteen = function(card){
  if(card.length == '15'){
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
    var cardTemp = 0, i;
    card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
    for(i = 0; i < 17; i ++){
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    card += arrCh[cardTemp % 11];
    return card;
  }
  return card;
};


String.prototype.isIdCard = function () {
  return checkCardNo(this);
};

String.prototype.getSexFromIdCard = function () {
  if (this.isIdCard()) {
    if (this.length < 18) {
      return null;
    }

    if (parseInt(this.substr(16, 1)) % 2 == 1) {
      return '男';
    } else {
      return '女';
    }
  }
  return null;
};





// WEBPACK FOOTER //
// ./src/js/extentions-tool.js